// Copyright (c) Ping. All rights reserved.

import { log } from '@core/log/log';

import { type PushWakePayload,wakeFromPushDelivery } from './pushWake';
import { takePendingPushWake } from './pushWakeRoute';

/** Runs inbox wake for a push payload (SW postMessage or deeplink). */
export async function processPushWakePayload(payload: PushWakePayload): Promise<void> {
  await wakeFromPushDelivery(payload);
}

/** Drains sessionStorage pending wake after auth bootstrap. */
export async function drainPendingPushWake(): Promise<void> {
  const payload = takePendingPushWake();
  if (payload === null) {
    return;
  }
  log.info({
    event: 'push.wake.pending',
    deliveryIdPrefix: payload.delivery_id?.slice(0, 8),
  });
  await processPushWakePayload(payload);
}
